module.exports = __webpack_public_path__ + "static/footer-2cc9d3b1217069c66f5ba46dfd5cc452.png";